import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { useSelectContext } from '../Select.hooks'

import {
  QA_DELETE_SELECT_ALL_BTN,
  QA_NAME_SELECT_ALL_BTN,
} from './SelectDropdownListSelectAllOption.constants'

import * as styles from './SelectDropdownListSelectAllOption.module.css'

import DeleteIcon from '../../../icons/delete.svg'

function SelectDropdownListSelectAllOption({
  Element = 'div',
  className = styles.SelectDropdownListSelectAllOption,
  clearAllButtonProps,
  disabled,
  selectAllButtonProps,
}) {
  const { t } = useTranslation()

  const { handleClear, handleSelectAll, showSelected, value } =
    useSelectContext()

  return (
    <Element className={className}>
      <Button.Text
        {...selectAllButtonProps}
        disabled={showSelected || disabled}
        qaName={QA_NAME_SELECT_ALL_BTN}
        text={t('Common.SelectDropdownListSelectAllButtonTextKey')}
        onClick={handleSelectAll}
      />
      <Button.Icon
        {...clearAllButtonProps}
        isGrey
        Icon={DeleteIcon}
        className={styles.deleteIcon}
        disabled={disabled || !value || value?.length === 0}
        qaName={QA_DELETE_SELECT_ALL_BTN}
        tooltip={t('Common.SelectDropdownListClearAllButtonTooltipKey')}
        onClick={handleClear}
      />
    </Element>
  )
}

export default SelectDropdownListSelectAllOption
